import React from 'react';
import svgMap from './svg.data';
import { useBrandingContext } from 'app-context/BrandingsContext';
import BotsSvg from 'assets/icons/sidebar-icons/BotsSvg';
import styles from './withBrandingColor.module.scss';

const SvgWithBranding = ({
  type,
  color,
  className = '',
  onClick,
  style,
  hasContainer = true,
  containerClassname = '',
  ...props
}) => {
  const { brandingData } = useBrandingContext();
  const { page_TextColor } = brandingData;

  const resolvedColor = color || page_TextColor;
  const SvgComponent = svgMap[type] || BotsSvg;

  if (
    type === 'edit' ||
    (type === 'delete2' && hasContainer) ||
    type === 'eye' ||
    type === 'add-member'
  ) {
    return (
      <div
        onClick={onClick}
        className={`${styles['edit-svg-wrapper']} ${
          type === 'delete2'
            ? styles['delete-color']
            : type === 'edit'
            ? styles['edit-color']
            : styles[type ?? '']
        } ${containerClassname}`}
      >
        <SvgComponent
          className={className}
          style={{ ...style }}
          color={resolvedColor}
          {...props}
        />
      </div>
    );
  }

  return (
    <SvgComponent
      onClick={onClick}
      className={className}
      style={{ ...style }}
      color={resolvedColor}
      {...props}
    />
  );
};

export default SvgWithBranding;
